import React, { Component } from 'react'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import MaterialTable from 'material-table'
import { LookaheadTag } from '../../models/LookaheadTag'
import { Chip, Select, MenuItem, Divider, Button, MuiThemeProvider, createMuiTheme } from '@material-ui/core'
import { Commitment, CommitmentEntry, CommitmentStatus } from '../../actions/lookahead.actions'
import { ClassNameMap } from '@material-ui/core/styles/withStyles'
import { SimpleCommitment, TradePPC } from '../../selectors/lookahead.selector'
import { ResponsiveBar } from '@nivo/bar'
import { Tag } from '../../models/Tag'
import { Variance } from '../../utils/Variance'
import DeletePPCReportDialog from '../Dialogs/DeletePPCReportDialog'
import GREEN from '@material-ui/core/colors/GREEN';

interface Props {
    hasCommitments: boolean;
    selectedCommitment: Commitment | undefined
    simpleCommitments: SimpleCommitment[],
    classes: ClassNameMap,
    commitmentId: string,
    tags: Record<string, LookaheadTag>,
    ppcPerTrade: Record<string, TradePPC>
    commitmentLog: CommitmentEntry[],
    showDeletePPCDialog: (commitment: string) => void,
    updatePPCSelectedCommitment: (commitmentId: string) => void
}
  
type State = {

}

class PPCReportScreen extends Component<Props, State> {

    renderCommitmentMenu = () => {
        return this.props.simpleCommitments.map((simpleCommitment :SimpleCommitment) => {
            return (
              <MenuItem value={simpleCommitment.uid}>{simpleCommitment.name}</MenuItem>
            )
          })
    }

    renderCommitmentStatusColor = () => {
      const { selectedCommitment } = this.props
      if(selectedCommitment?.status === CommitmentStatus.WorkingOn) {
        return GREEN[500]
      }
  
      return	
    }

    renderCommitmentText = () => {
      const { selectedCommitment } = this.props
  
      if(selectedCommitment?.status === CommitmentStatus.Done) {
        return "Non Active"
      }
  
      return "Active"
    }
  

    renderCommitmentStatus = () => {
        const { selectedCommitment } = this.props
        if(!selectedCommitment) {
          return
        }

        return (
          <MuiThemeProvider theme={theme =>
              createMuiTheme({
                ...theme,
                overrides: {
                  MuiChip: {
                    colorPrimary: {
                      backgroundColor: this.renderCommitmentStatusColor()
                    }
                  }
                }
              })
            }
          >
            <div style ={{marginLeft: 16}}>
              <Chip color="primary" label={this.renderCommitmentText()} />
            </div>
          </MuiThemeProvider>
        )
    }

    renderDesktopTopBar = () => {
        const { classes, commitmentId } = this.props;
       

        return (
          <div className={classNames(classes.overviewHeader)}>
            <div className={classNames(classes.leftOverviewHeader)}>
              <Typography
                className={classNames(classes.sectionPaperHeader)}
                variant="headline"
                noWrap >
                Commitment Report
              </Typography>
              {this.renderCommitmentStatus()}
            </div>
            <Select
                style={{ marginRight: 32 }}
                onChange={this.handleCommitmentSelect}
                value={commitmentId}
              >
                  {this.renderCommitmentMenu()}
                  <Divider />
                  <MenuItem value={"delete"}>Delete Commitment Report</MenuItem>

            </Select>
          </div>
        )
    }

    handleCommitmentSelect = (event:any) => {
        const { updatePPCSelectedCommitment } = this.props
        const key = event.target.value

        if(key === 'delete') {
          const { showDeletePPCDialog, commitmentId } = this.props
          showDeletePPCDialog(commitmentId)
          return
        }

        updatePPCSelectedCommitment(key)
    }

    renderPPCChart = () => {
        const { selectedCommitment, ppcPerTrade } = this.props

        if(!selectedCommitment) {
            return
        }

        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', height: '300px', width: '100%', padding: '16px'}}>
                <ResponsiveBar
                    labelFormat={ v => `${v}%`}

                    maxValue={100}
                    margin={{
                        "top": 50,
                        "right": 60,
                        "bottom": 50,
                        "left": 60
                    }}
                    colors={({ data }) => {
                        return data.tradeColor
                    }}

                    padding={0.5}
                    labelTextColor= 'inherit:darker(1.4)'
                    labelSkipWidth= {16}
                    labelSkipHeight={16}
                    axisBottom= {{
                        legend: 'Trade',
                        legendPosition: 'middle',
                        legendOffset: 32,
                        tickSize: 5,
                        tickPadding: 5
                    }}

                    axisLeft= {{
                        format: v => `${Math.trunc(v)}%`,

                        legendPosition: 'middle',
                        legend: 'PPC',
                        legendOffset: -40
                    }}

                    data={Object.values(ppcPerTrade)}
                    indexBy='tradeName'
                    keys={['ppc']}
                    animate={true}
                    motionStiffness={90}
                    motionDamping={15}
                />
            </div>
        )
    }

    renderVariance = (rowData: CommitmentEntry) => {
        return Variance[rowData.variance]
    }

    renderCompletedDate = (rowData: CommitmentEntry) => {
      if(!!rowData.actualDate) {
        return rowData.actualDate
      }

      return rowData.originalDate
    }

    renderTrade = (rowData: CommitmentEntry) => {
        const { trades } = this.props
        const tagId = rowData.uid
    
        const tag = this.props.tags[tagId] as Tag | undefined
    
        if (!tag || !trades || !trades[tag.tradeId]) {
          return
        }
    
        const trade = trades[tag.tradeId]
    
        return (
          <MuiThemeProvider theme={theme =>
            createMuiTheme({
              ...theme,
              overrides: {
                MuiChip: {
                  colorPrimary: {
                    backgroundColor: trade.color
                  }
                }
              }
            })
          }
          >
            <div style={{ marginLeft: 16 }}>
              <Chip color="primary" label={trade.name} />
            </div>
          </MuiThemeProvider>
        )
      }

    renderName = (rowData: CommitmentEntry) => {
        const tagId = rowData.uid
    
        const tag = this.props.tags[tagId] as Tag | undefined
    
        if (!tag) {
          return
        }
    
        return tag.name
    }

    renderVarianceTable = () => {
        const { commitmentLog } = this.props;

        return (
            <div style={{margin: '16px', height: '100%'}}>
                <MaterialTable
                        components={{
                        Toolbar: () => (
                            <div >
                            </div>
                        )
                        }}
                        columns={[
                        {
                            title: 'Name',
                            render: (rowData: any) => {
                            return this.renderName(rowData)
                            },
                            cellStyle: {
                            backgroundColor: '#f9fcfd',
                            padding: '4px 16px'
                            },
                            headerStyle: {
                            padding: '4px 16px'
                            }
                        },
                        {
                            title: 'Trade',
                            render: rowData => {
                            return this.renderTrade(rowData)
                            },
                            cellStyle: {
                            backgroundColor: '#f9fcfd',
                            padding: '4px 16px'
                            },
                            headerStyle: {
                            padding: '4px 16px'
                            }
                        },
                        {
                            title: 'Promise Date',
                            field: 'originalDate',
                            cellStyle: {
                            backgroundColor: '#f9fcfd',
                            padding: '4px 16px'
                            },
                            headerStyle: {
                            padding: '4px 16px'
                            }
                        },
                        {
                            title: 'Completed Date',
                            field: 'actualDate',
                            render: rowData => {
                              return this.renderCompletedDate(rowData)
                            },
                            cellStyle: {
                            backgroundColor: '#f9fcfd',
                            padding: '4px 16px'
                            },
                            headerStyle: {
                            padding: '4px 16px'
                            }
                        },
                        {
                            title: 'Variance',
                            render: rowData => {
                            return this.renderVariance(rowData)
                            },
                            cellStyle: {
                            backgroundColor: '#f9fcfd',
                            padding: '4px 16px'
                            },
                            headerStyle: {
                            padding: '4px 16px'
                            }
                        }
                        ]}
                        data={commitmentLog}
                        title=""
                        options={{
                        pageSize: 10
                        }}
                    />
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <DeletePPCReportDialog />
                {this.renderDesktopTopBar()}
                {this.renderPPCChart()}
                {this.renderVarianceTable()}
            </React.Fragment>
        )
    }
}

export default PPCReportScreen


// WEBPACK FOOTER //
// ./src/components/PPC_Reports/PPCReportScreen.tsx